function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Input from '../Input';
import Button from '../Button';
import Row from '../Layout/Row';
var propTypes = {
  id: PropTypes.string,
  canPrevious: PropTypes.bool,
  canNext: PropTypes.bool,
  ofText: PropTypes.string,
  previousText: PropTypes.string,
  page: PropTypes.number,
  pages: PropTypes.number,
  onPageChange: PropTypes.func
};

var PaginationMobile = /*#__PURE__*/function (_Component) {
  _inherits(PaginationMobile, _Component);

  var _super = _createSuper(PaginationMobile);

  function PaginationMobile(props) {
    var _this;

    _classCallCheck(this, PaginationMobile);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "goPreviousPage", function () {
      var canPrevious = _this.props.canPrevious;
      var page = _this.state.page;
      if (!canPrevious) return;

      _this.changePage(page - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "goNextPage", function () {
      var canNext = _this.props.canNext;
      var page = _this.state.page;
      if (!canNext) return;

      _this.changePage(page + 1);
    });

    _defineProperty(_assertThisInitialized(_this), "goLastPage", function () {
      var _this$props = _this.props,
          canNext = _this$props.canNext,
          pages = _this$props.pages;
      var pageArray = Array(pages).fill().map(function (v, i) {
        return i + 1;
      });
      if (!canNext) return;

      _this.changePage(pageArray.length - 1);
    });

    _defineProperty(_assertThisInitialized(_this), "goFirstPage", function () {
      var canPrevious = _this.props.canPrevious;
      if (!canPrevious) return;

      _this.changePage(0);
    });

    _this.getSafePage = _this.getSafePage.bind(_assertThisInitialized(_this));
    _this.changePage = _this.changePage.bind(_assertThisInitialized(_this));
    _this.applyPage = _this.applyPage.bind(_assertThisInitialized(_this));
    _this.state = {
      page: props.page
    };
    return _this;
  }

  _createClass(PaginationMobile, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.page !== this.props.page) {
        this.setState({
          page: this.props.page
        });
      }
    }
  }, {
    key: "getSafePage",
    value: function getSafePage(pageArg) {
      var _this$props2 = this.props,
          page = _this$props2.page,
          pages = _this$props2.pages;
      var calcPage = Number.isNaN(pageArg) ? page : pageArg;
      return Math.min(Math.max(calcPage, 0), pages - 1);
    }
  }, {
    key: "applyPage",
    value: function applyPage(e) {
      if (e) {
        e.preventDefault();
      }

      var page = this.state.page; // eslint-disable-next-line react/destructuring-assignment

      this.changePage(page === '' ? this.props.page : page);
    }
  }, {
    key: "changePage",
    value: function changePage(pageArg) {
      var _this$props3 = this.props,
          page = _this$props3.page,
          onPageChange = _this$props3.onPageChange;
      var pageVar = this.getSafePage(pageArg);
      this.setState({
        page: pageVar
      });

      if (page !== pageVar) {
        onPageChange(pageVar);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          id = _this$props4.id,
          pages = _this$props4.pages,
          canPrevious = _this$props4.canPrevious,
          canNext = _this$props4.canNext,
          ofText = _this$props4.ofText,
          previousText = _this$props4.previousText;
      var page = this.state.page;
      return /*#__PURE__*/React.createElement(Row, {
        justify: "center"
      }, /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_to_beginning",
        onClick: this.goFirstPage,
        disabled: !canPrevious,
        className: "marginright-md",
        "aria-label": "Go to first page"
      }, previousText), /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_back",
        onClick: this.goPreviousPage,
        disabled: !canPrevious,
        className: "marginright-md",
        "aria-label": "Go to previous page"
      }, previousText), /*#__PURE__*/React.createElement("div", {
        className: "pagination__input"
      }, /*#__PURE__*/React.createElement("span", {
        className: "-pageInfo paddingleft-lg"
      }, "Page"), /*#__PURE__*/React.createElement(Input, {
        name: id ? "".concat(id, "_pageJump") : 'pageJump',
        className: "page__input",
        size: "small",
        value: page === '' ? '' : page + 1,
        onChange: function onChange(e) {
          var val = e.target.value;
          var pageNumber = val - 1;

          if (val === '') {
            return _this2.setState({
              page: val
            });
          }

          return _this2.setState({
            page: _this2.getSafePage(pageNumber)
          });
        },
        onBlur: this.applyPage,
        onKeyPress: function onKeyPress(e) {
          if (e.which === 13 || e.keyCode === 13) {
            _this2.applyPage();
          }
        }
      }), ofText, " ", /*#__PURE__*/React.createElement("span", {
        className: "-totalPages paddingright-lg"
      }, pages || 1)), /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_forward",
        onClick: this.goNextPage,
        disabled: !canNext,
        className: "marginright-md",
        "aria-label": "Go to next page"
      }), /*#__PURE__*/React.createElement(Button, {
        kind: "secondary",
        size: "small",
        icon: "only",
        iconName: "arrow_to_end",
        onClick: this.goLastPage,
        disabled: !canNext,
        className: "marginright-md",
        "aria-label": "Go to last page"
      }, previousText));
    }
  }]);

  return PaginationMobile;
}(Component);

PaginationMobile.propTypes = propTypes;
PaginationMobile.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "getSafePage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "pageArg",
      "type": null
    }],
    "returns": null
  }, {
    "name": "goPreviousPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "goNextPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "goLastPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "goFirstPage",
    "docblock": null,
    "modifiers": [],
    "params": [],
    "returns": null
  }, {
    "name": "applyPage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "e",
      "type": null
    }],
    "returns": null
  }, {
    "name": "changePage",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "pageArg",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "PaginationMobile",
  "props": {
    "id": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "canPrevious": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "canNext": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "ofText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "previousText": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    },
    "page": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "pages": {
      "type": {
        "name": "number"
      },
      "required": false,
      "description": ""
    },
    "onPageChange": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};
export default PaginationMobile;